import GallaboxVideo from "@components/GallaboxVideo";
import NewLayout from "@components/new-ui/Layout";
import TwoCardTestimonial from "@components/TwoCardTestimonial";
import "react-intl-tel-input/dist/main.css";

const MastercardPage: React.FC = () => {
    const advantagesTop = [
        {
            img: "top-one",
            text: "Provide personalized engagement",
        },
        {
            img: "top-two",
            text: "Reduce sales cycles",
        },
        {
            img: "top-three",
            text: "Re-engage with dormant customers",
        },
    ];
    const advantagesBot = [
        {
            img: "bot-one",
            text: "Save time with automation",
        },
        {
            img: "bot-two",
            text: "Generate qualified leads faster",
        },
        {
            img: "bot-three",
            text: "Build a strong customer base",
        },
    ];

    const keyFeatures = [
        {
            img: "1",
            boldText: "Personalized WhatsApp chatbots,",
            text: " for all business use cases, to instantly engage with customers",
        },
        {
            img: "2",
            boldText: "Shared team inbox",
            text: " that brings all customer conversations on Whatsapp into a central dashboard",
        },
        {
            img: "3",
            boldText: "Broadcast campaigns",
            text: " that help send promotional messages to targeted customers, on WhatsApp",
        },
        {
            img: "4",
            boldText: "Seamless integration",
            text: " with CRM, ecommerce, payment processors, and other available third party platforms",
        },
    ];

    const aboutOffer = [
        "This offer is applicable on the 12-month subscription of Gallabox’s Scale or Custom plans.",
        "A functional business website and a live Facebook business page are required for verification purposes.",
        "Gallabox can help you get WhatsApp Official APIs for integration, however, allocation is subject to compliance with WhatsApp's Commerce Policy.",
        "Mastercard clients need to pay WhatsApp usage charges as per our conversational pricing policy once they exhaust their 1000 free service (user-initiated) conversations/month, which is subject to Meta’s pricing update.",
        "Mastercard customers can opt for Gallabox’s prepaid credits and they can recharge credits based on their consumption.",
        "Payments made by Business Mastercard users will be processed via Stripe Payment Gateway by Gallabox. ",
        "If you agree to these terms and conditions, please sign up for the offer and we'll send you a promotional code.",
        "Note: This offer cannot be clubbed with any other existing promotions.",
    ];

    return (
        <NewLayout
            title="Annual Plan Offer for Master card | Gallabox"
            description="Get $75 off on Gallabox’s annual subscription plan"
            canonical="https://gallabox.com/commercial-card-mastercard-offers"
        >
            <header className="md:pt-24 pt-10 visa-header-banner flex justify-center items-center px-2">
                <a href="/">
                    <img src="https://assets.gallabox.com/gb-home/visa-offer/gallabox-logo.png" style={{ position: "absolute", top: "56px", left: "55px" }} />
                </a>
                <div className="flex font-semibold flex-wrap md:flex-nowrap mt-10 md:mt-0" style={{ fontSize: "65px", fontFamily: "Raleway", width: "100%", maxWidth: "1150px" }}>
                    <div className="flex flex-col justify-center items-center md:items-start text-white">
                        <h1 style={{ fontFamily: "Raleway", width: "100%", maxWidth: "790px" }} className="m-0 lg:text-5xl">
                            Unlock $75 off on WhatsApp business solution from Gallabox with your Business Mastercard
                        </h1>
                        <div className="flex flex-col justify-center md:justify-start">
                            <a
                                style={{ fontFamily: "sans-serif" }}
                                href="https://app.gallabox.com/signup?utm_source=mastercard"
                                className="jsx- my-8 md:mt-5 text-center md:text-left  main-button outline-none focus:outline-none start-trial-btn hover:no-underline hover:shadow-lg transition duration-300 ease-in-out inline-flex items-center justify-center md:justify-start gap-1 start-trial-btn font-bold text-lg"
                            >
                                Sign Up
                            </a>
                        </div>
                    </div>
                    <img className="md:w-6/12" src="https://assets.gallabox.com/gb-home/mastercard-head.png" />
                </div>
            </header>
            <section className="max-w-7xl text-center mx-auto mt-20 px-4">
                <h2 className="pb-5">Close deals faster using WhatsApp</h2>
                <p className="text-gray-600 font-normal" style={{ fontSize: "17px" }}>
                    Welcome, nurture, and convert leads into customers by leveraging Gallabox’s WhatsApp Business Automation Solution. Gallabox is a WhatsApp App Builder that helps
                    fast-growing businesses manage and automate all their customer conversations.
                </p>
            </section>
            <section className="max-w-6xl mx-auto mt-20 px-4">
                <h2 className="pb-5 text-center">Key Features</h2>
                <div className="flex flex-wrap gap-8">
                    {keyFeatures?.map((data) => (
                        <div className="flex gap-7 items-center key-features-visa" key={data?.img}>
                            <img src={`https://assets.gallabox.com/gb-home/visa-offer/key-features-${data?.img}.png`} />
                            <span className="text-gray-600 font-normal">
                                <span className="font-bold">{data?.boldText}</span>
                                {data?.text}
                            </span>
                        </div>
                    ))}
                </div>
                <div className="flex justify-center mt-10">
                    <a type="submit" className="font-semibold signup-btn-visa mt-2" href="https://app.gallabox.com/signup?utm_source=mastercard">
                        Signup now
                    </a>
                </div>
            </section>

            <section className="max-w-6xl mx-auto my-24 mb-20 px-4">
                <h2 className="pb-2 text-center">Terms</h2>
                <ul className="text-gray-600 pl-5 text-base font-normal">
                    {aboutOffer?.map((data) => (
                        <li key={data}>{data}</li>
                    ))}
                </ul>
            </section>

            <section className="flex flex-col gap-5 mb-16 px-4">
                <h2 className="text-center">Instantly boost your business results with Gallabox</h2>
                <div className="flex justify-center">
                    <div className="flex flex-row gap-5 flex-wrap justify-center">
                        {advantagesTop?.map((each) => (
                            <div key={each.text} className="flex wa-advan-box py-2.5 px-5 items-center  w-full md:w-auto">
                                <img src={`/whatsapp/advan-${each.img}.png`} className="mr-3.5" />
                                <p className="text-gray-700 font-bold">{each.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="flex justify-center">
                    <div className="flex flex-row gap-5 flex-wrap justify-center">
                        {advantagesBot?.map((each) => (
                            <div key={each.text} className="flex wa-advan-box py-2.5 px-5 items-center w-full md:w-auto">
                                <img src={`/whatsapp/advan-${each.img}.png`} className="mr-3.5" />
                                <p className="text-gray-700 font-bold">{each.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section>
                <TwoCardTestimonial />
            </section>
            <section className="relative bg-rhino mob-pad">
                <GallaboxVideo />
            </section>
        </NewLayout>
    );
};
export default MastercardPage;
